import {useState} from 'react'
import {useToast} from '../Toats'

type Props = {
  label: string
  value: string
  className?: string
}

const CopyCode = ({label, value, className = ''}: Props) => {
  const {toggleToast} = useToast()
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      toggleToast('Código copiado.', 'success')
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      toggleToast('Não foi possível copiar.', 'error')
    }
  }

  return (
    <div className={`d-flex align-items-center flex-wrap gap-3 ${className}`}>
      <span className='text-muted fs-6'>{label}</span>
      <button
        type='button'
        className='btn btn-sm btn-light border border-gray-300 d-inline-flex align-items-center gap-2 px-3 py-1 text-gray-700 fs-7'
        style={{fontFamily: 'monospace'}}
        title={copied ? 'Copiado' : 'Clique para copiar'}
        onClick={copy}
      >
        {value}
        <i className={`bi ${copied ? 'bi-check2 text-success' : 'bi-copy text-gray-600'} fs-6 p-0`}></i>
      </button>
    </div>
  )
}

export {CopyCode}
